var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSongListIcon = function SvgSongListIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 6.667a1.333 1.333 0 0 0 0 2.667h14.667a1.333 1.333 0 1 0 0-2.667zm20 0c-.736 0-1.333.597-1.333 1.333v12.228A4 4 0 1 0 25.334 24V9.334H28a1.333 1.333 0 1 0 0-2.667zM2.667 16c0-.736.597-1.333 1.333-1.333h14.667a1.333 1.333 0 1 1 0 2.667H4A1.333 1.333 0 0 1 2.667 16M4 22.667a1.333 1.333 0 1 0 0 2.667h9.333a1.333 1.333 0 0 0 0-2.667z"
  })));
};
export default SvgSongListIcon;